import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader, Section, EmptyState, Pill } from "@/components/ui-kit";
import { Modal } from "./Books";
import { Plus } from "lucide-react";
import { toast } from "sonner";

const emptyC = { name: "", type: "libreria", email: "", phone: "", nif: "", address: "", city: "", country: "España", notes: "" };
const TYPES = ["libreria", "escuela", "feria", "particular", "otro"];

export default function Customers() {
  const [items, setItems] = useState([]);
  const [q, setQ] = useState("");
  const [show, setShow] = useState(false);
  const [editing, setEditing] = useState(null);
  const [form, setForm] = useState(emptyC);

  async function load() {
    const { data } = await api.get("/customers", { params: q ? { q } : {} });
    setItems(data);
  }
  useEffect(() => { load(); /* eslint-disable-next-line */ }, [q]);

  async function submit(e) {
    e.preventDefault();
    try {
      if (editing) await api.put(`/customers/${editing.id}`, form);
      else await api.post("/customers", form);
      toast.success("Guardado");
      setShow(false); load();
    } catch (e) { toast.error(e?.response?.data?.detail || "Error"); }
  }

  async function del(id) {
    if (!window.confirm("¿Eliminar cliente?")) return;
    await api.delete(`/customers/${id}`); load();
  }

  return (
    <div data-testid="customers-page">
      <PageHeader
        title="Clientes & contactos"
        subtitle="Librerías, escuelas, ferias y particulares."
        actions={
          <button onClick={() => { setEditing(null); setForm(emptyC); setShow(true); }}
            data-testid="new-customer-button"
            className="bg-brand hover:bg-brand-hover text-white text-sm px-4 py-2 rounded-sm inline-flex items-center gap-2">
            <Plus size={16} strokeWidth={1.5} /> Nuevo cliente
          </button>
        }
      />
      <div className="mb-5 max-w-md">
        <input value={q} onChange={(e) => setQ(e.target.value)}
          placeholder="Filtrar por nombre, ciudad, email…"
          data-testid="customers-filter"
          className="w-full bg-white border border-line rounded-sm px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand" />
      </div>
      <Section>
        {items.length === 0 ? <EmptyState title="Sin clientes" description="Añade tu primera librería, escuela o contacto." testid="customers-empty" /> : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead><tr className="text-[11px] uppercase tracking-[0.1em] text-ink2 bg-sidebar/40">
                <th className="text-left px-5 py-3 font-medium">Nombre</th>
                <th className="text-left px-5 py-3 font-medium">Tipo</th>
                <th className="text-left px-5 py-3 font-medium">Ciudad</th>
                <th className="text-left px-5 py-3 font-medium">Email</th>
                <th className="text-left px-5 py-3 font-medium">NIF</th>
                <th className="text-right px-5 py-3 font-medium">Acciones</th>
              </tr></thead>
              <tbody>
                {items.map(c => (
                  <tr key={c.id} className="border-t border-line hover:bg-sidebar/30" data-testid={`customer-row-${c.id}`}>
                    <td className="px-5 py-3 font-medium">{c.name}</td>
                    <td className="px-5 py-3"><Pill tone="muted">{c.type}</Pill></td>
                    <td className="px-5 py-3 text-ink2">{c.city || "—"}</td>
                    <td className="px-5 py-3 text-ink2 font-mono text-xs">{c.email || "—"}</td>
                    <td className="px-5 py-3 text-ink2 font-mono text-xs">{c.nif || "—"}</td>
                    <td className="px-5 py-3 text-right">
                      <button onClick={() => { setEditing(c); setForm({ ...emptyC, ...c }); setShow(true); }} className="text-xs text-ink2 hover:text-ink mr-3">Editar</button>
                      <button onClick={() => del(c.id)} className="text-xs text-crimson hover:opacity-80">Borrar</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Section>

      {show && (
        <Modal title={editing ? "Editar cliente" : "Nuevo cliente"} onClose={() => setShow(false)}>
          <form onSubmit={submit} className="grid grid-cols-2 gap-4" data-testid="customer-form">
            <F label="Nombre" required span={2}><input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className={IN} data-testid="customer-name" /></F>
            <F label="Tipo"><select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} className={IN}>{TYPES.map(t => <option key={t}>{t}</option>)}</select></F>
            <F label="NIF/CIF"><input value={form.nif} onChange={(e) => setForm({ ...form, nif: e.target.value })} className={IN} /></F>
            <F label="Email"><input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={IN} /></F>
            <F label="Teléfono"><input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} className={IN} /></F>
            <F label="Dirección" span={2}><input value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} className={IN} /></F>
            <F label="Ciudad"><input value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} className={IN} /></F>
            <F label="País"><input value={form.country} onChange={(e) => setForm({ ...form, country: e.target.value })} className={IN} /></F>
            <F label="Notas" span={2}><textarea rows={2} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} className={IN} /></F>
            <div className="col-span-2 flex justify-end gap-2">
              <button type="button" onClick={() => setShow(false)} className="px-4 py-2 text-sm border border-line rounded-sm hover:bg-sidebar">Cancelar</button>
              <button type="submit" data-testid="customer-submit" className="px-4 py-2 text-sm bg-brand hover:bg-brand-hover text-white rounded-sm">Guardar</button>
            </div>
          </form>
        </Modal>
      )}
    </div>
  );
}

const IN = "w-full bg-white border border-line rounded-sm px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-brand focus:border-brand";
function F({ label, children, required, span = 1 }) {
  return (
    <label className={`block ${span === 2 ? "col-span-2" : ""}`}>
      <span className="text-[11px] uppercase tracking-[0.12em] text-ink2">{label}{required && <span className="text-brand"> *</span>}</span>
      <div className="mt-1">{children}</div>
    </label>
  );
}
